import { memo } from 'react';
import FiltersMenu from '@/srp/FiltersMenu';
import { FILTER_DESKTOP_SCROLL_CONTAINER_ID } from '@/srp/FiltersMenu/constants';
import FiltersMenuSkeleton from '@/srp/FiltersMenu/FiltersMenuSkeleton';
import {
  useFacetsHydrated,
  useIsServerDriven
} from '~/context/srp/SrpNavModeContext';
import styles from './Filters.module.css';
import { Aside } from './Filters.styles';
import AppliedFilters from '../AppliedFilters';

// memo with no props: blocks a parent MainLayout re-render (e.g. inventory change
// during pagination) from cascading into the filter menu.
function Filters() {
  const isServerDriven = useIsServerDriven();
  const facetsHydrated = useFacetsHydrated();
  // facetData.isLoaded flips true on the shell's baseline facets before the island
  // streams the real set; gate on facetsHydrated so we don't flash baseline options.
  const showFacetSkeleton = isServerDriven && !facetsHydrated;

  return (
    <Aside
      data-testid="filters-aside"
      className={styles.scrollContainer}
      id={FILTER_DESKTOP_SCROLL_CONTAINER_ID}
    >
      <div className="sticky top-0 z-[10]">
        <AppliedFilters />
      </div>
      {showFacetSkeleton ? <FiltersMenuSkeleton /> : <FiltersMenu />}
    </Aside>
  );
}

export default memo(Filters);
